// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__+SYGf","title":"styles_title__RrbT+","edit":"styles_edit__o4j-H"};